import { render, staticRenderFns } from "./Abouts.vue?vue&type=template&id=509522f6&scoped=true&"
var script = {}
import style0 from "./Abouts.vue?vue&type=style&index=0&id=509522f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509522f6",
  null
  
)

export default component.exports